module.exports = __webpack_public_path__ + "static/media/filter-language.f19ca51b.svg";